import React from 'react';
import PropTypes from 'prop-types';

const SVG = ({width = '100%', height = '100%', className = ''}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 56 56"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>refresh-resting</title>
    <desc>Created with Sketch.</desc>
    <g id="Desktop-v1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="zoom-in-control" transform="translate(-35.000000, -105.000000)">
        <g id="refresh-resting" transform="translate(38.000000, 108.000000)">
          <rect
            id="Rectangle"
            stroke="#E5E5E5"
            strokeWidth="3"
            fill="#FFFFFF"
            x="-1.5"
            y="-1.5"
            width="53"
            height="53"
            rx="25"
          />
          <path
            d="M21.2520816,25.0638408 L24.1760339,27.9728902 L21.6781155,30.4606385 L29.1621565,30.4606385 C30.3098113,30.4606385 31.2437552,29.5310135 31.2437552,28.388666 L31.2437552,28.388666 L31.2437552,26.5929565 L35.4069525,26.5929565 L35.4069525,28.388666 C35.4069525,31.8157086 32.6051207,34.6045836 29.1621565,34.6045836 L29.1621565,34.6045836 L21.6781155,34.6045836 L24.1760339,37.0909506 L21.2520816,40 L13.75,32.532611 L21.2520816,25.0638408 Z M28.7465307,11.25 L36.25,18.7187703 L28.7465307,26.1875405 L25.8225784,23.2771098 L28.3204968,20.7907428 L20.8364557,20.7907428 C19.688801,20.7907428 18.7548571,21.7203678 18.7548571,22.8627153 L18.7548571,22.8627153 L18.7548571,24.6584248 L14.5916597,24.6584248 L14.5916597,22.8627153 C14.5916597,19.4356728 17.3934915,16.6467978 20.8364557,16.6467978 L20.8364557,16.6467978 L28.3204968,16.6467978 L25.8225784,14.1604307 L28.7465307,11.25 Z"
            id="refresh-20px"
            stroke="#FFFFFF"
            strokeWidth="0.661764706"
            fill="#677383"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);

SVG.propTypes = {
  /** The class name of the SVG. */
  className: PropTypes.string,

  /** The height of the SVG. */
  height: PropTypes.string,

  /** The width of the SVG. */
  width: PropTypes.string,
};

export default SVG;
